import { Text, View } from 'react-native'
import { CircleAlert } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface InlineAlertProps {
  message: string
}

export function InlineAlert({ message }: InlineAlertProps) {
  return (
    <View className="w-full flex-row items-start gap-3 rounded-md border border-accent/20 bg-accent/10 px-4 py-3">
      <CircleAlert size={20} color={colors.accent.DEFAULT} strokeWidth={2} />
      <Text className="min-w-0 flex-1 text-sm font-normal text-primary">{message}</Text>
    </View>
  )
}
